export const PRE_ORDER_FLOW_SUGGESTION_TABLE = "preOrderFlowSuggestions"
export const PRE_ORDER_FLOW_SUGGESTION_TABLE_SCHEMA =
  "id, companyId, targetId, syncId"
